global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import AOS from 'aos';
import 'aos/dist/aos.css';

import Masonry from 'masonry-layout';

$(document).ready(function (){

    // AOS animations
    $(function() {
        AOS.init({
            duration: 1000,
            once: true,
        });
    });

    if ($('.grid-gallery').length > 0){
        let gallery = new Masonry('.grid-gallery', {
            itemSelector: '.grid-item',
            columnWidth: '.grid-item',
            percentPosition: true,
            gutter: 10
        })

        gallery.imagesLoaded().progress( function() {
            gallery.masonry('layout');
        });
    }

    // headroom
    if ($('.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let headroomOpt = {
            offset: 150,
        }
        let headroom = new Headroom(headroomEl, headroomOpt);
        headroom.init();
    }

    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });

    let burgerButton = $('.burger-button');
    let mainMenu = $('.sub-menu-general')
    let btx = $('.bi-x')
    let btmenu = $('.bi-list')
    const header = $('header')

    burgerButton.on( "click", function(event) {
        event.preventDefault()
        if (!burgerButton.hasClass('opened')){
            event.preventDefault()
            header.addClass('color-bg-blue-dark')
            btx.removeClass('d-none')
            btmenu.addClass('d-none')
            burgerButton.addClass('opened')
            mainMenu.stop().slideDown('fast');
            $('body').addClass('overflow-hidden')
            event.stopPropagation()
        } else {
            event.preventDefault()
            header.removeClass('color-bg-blue-dark')
            btx.addClass('d-none')
            btmenu.removeClass('d-none')
            burgerButton.removeClass('opened')
            event.preventDefault()
            mainMenu.stop().slideUp('fast');
            $('body').removeClass('overflow-hidden')
            event.stopPropagation()
        }
    });

    let subMenuOpener = $('.header__item-has-submenu');
    let subMenuOpenerS = $('.header__item-has-submenu > span');

    if (window.innerWidth >= 1200){
        subMenuOpener.hover(function (e) {
            $(this).addClass('open');
            $(this).find('.header__nav-submenu-wrapper').stop().slideDown(400);
            e.stopPropagation()
        },function (e){
            $(this).removeClass('open');
            $(this).find('.header__nav-submenu-wrapper').stop().slideUp(400);
            e.stopPropagation()
        });
    } else {
        subMenuOpenerS.on('click', function (e) {
            e.preventDefault()
            if ($(this).parent().closest('.sub_header_opener').hasClass('open')){
                $(this).closest('.sub_header_opener').find('.header__nav-submenu-wrapper').stop().slideUp(400);
                $(this).closest('.sub_header_opener').removeClass('open');
            } else {
                $(this).closest('.sub_header_opener').find('.header__nav-submenu-wrapper').stop().slideDown(400);
                $(this).closest('.sub_header_opener').addClass('open');
            }
        })
    }

    let offSet = 100
    let fromTop = ($(window).scrollTop())
    let h_no_trigger = $('#h_no_trigger')

    window.onresize = function() {
        setHead()
    }
    setHead()
    function setHead(){
        if (!h_no_trigger[0]){
            if (fromTop >= offSet){
                if (!header.hasClass('color-bg-blue-dark')){
                    header.addClass('color-bg-blue-dark');
                }
            } else {
                header.removeClass('color-bg-blue-dark');
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop >= offSet){
                    if (!header.hasClass('color-bg-blue-dark')){
                        header.addClass('color-bg-blue-dark');
                    }
                } else {
                    header.removeClass('color-bg-blue-dark');
                }
            };
        } else {
            header.addClass('color-bg-blue-dark');
        }
    }
});
